<template>
  <el-tag
    class="tag"
    effect="dark"
    :type="type"
  >{{ score }}</el-tag>
</template>

<script>
export default {
  name: "GradeTag",
  props: {
    score: String,
  },
  computed: {
    type: function() {
      const score = Number(this.score)
      if (score > 90) {
        return "success";
      } else if (score > 75) {
        return "info";
      } else if (score > 60) {
        return "warning";
      } else {
        return "danger";
      }
    }
  }
}
</script>

<style scoped>
.tag {
  margin: auto 16px;
}
</style>